import { modalAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { modalCloseButton } from './button';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(modalAnatomy.keys);

const baseStyle = definePartsStyle({
  dialog: {
    bg: 'white',
    border: '1px',
    borderRadius: 'none',
    _dark: {
      bg: 'tmtBlack',
    },
  },
  dialogContainer: {
    p: 3,
  },
  overlay: {
    bg: 'blackAlpha.800',
  },
  header: {
    bgColor: 'accentColor',
    color: 'white',
    display: 'block',
    position: 'relative',
    textAlign: 'center',
    py: 3,
    px: 10,
    'h2, h3, h4': {
      color: 'white',
    },
  },
  closeButton: {
    ...modalCloseButton,
  },
  body: {
    bg: 'white',
    p: 5,
    textAlign: 'center',
    _dark: {
      bg: 'tmtBlack',
    },
  },
  footer: {
    bg: 'white',
    pt: 0,
    pb: 5,
    px: 5,
    _dark: {
      bg: 'tmtBlack',
    },
  },
});

const blueScribbleModal = definePartsStyle({
  // ...baseStyle,
  dialog: {
    bg: 'accentColor',
    border: '0',
    padding: { base: 8, lg: 16 },
    _dark: {
      bg: 'accentColor',
    },
  },
  header: {
    bg: 'transparent',
    padding: 0,
    mb: { base: 5, lg: 8 },
    position: 'static',
    _before: {
      content: '""',
      borderImage: 'url(/img/border-square.svg) 0 fill stretch',
      position: 'absolute',
      top: { base: '-8px', lg: '-10px' },
      left: { base: '-5px', lg: '-8px' },
      right: { base: '-8px', lg: '-10px' },
      bottom: { base: '-10px', lg: '-15px' },
    },
  },
  body: {
    bg: 'transparent',
    padding: 0,
    _dark: {
      bg: 'accentColor',
    },
  },
  // dialog: {
  //   bg: 'white',
  //   border: '1px',
  //   borderRadius: 'none',
  //   _dark: {
  //     bg: 'tmtBlack',
  //   },
  // },
  // dialogContainer: {
  //   p: 3,
  // },
  // overlay: {
  //   bg: 'blackAlpha.800',
  // },
  // header: {
  //   bgColor: 'accentColor',
  //   color: 'white',
  //   display: 'block',
  //   position: 'relative',
  //   textAlign: 'center',
  //   py: 3,
  //   px: 10,
  //   '*, h2, h3, h4': {
  //     color: 'white',
  //   },
  // },
  // closeButton: {
  //   ...modalCloseButton,
  // },
  // body: {
  //   bg: 'white',
  //   p: 5,
  //   textAlign: 'center',
  //   _dark: {
  //     bg: 'tmtBlack',
  //   },
  // },
  // footer: {
  //   bg: 'white',
  //   pt: 0,
  //   pb: 5,
  //   px: 5,
  //   _dark: {
  //     bg: 'tmtBlack',
  //   },
  // },
});

const sizes = {
  xl: definePartsStyle({
    dialog: {
      maxW: 'container.md',
      // boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
      // _dark: {
      //   boxShadow: '0 4px 20px rgba(255,255,255,0.15)',
      // },
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      p: { base: 5, md: 8 },
      gap: { base: 5, md: 8 },
    },
  }),
};

export default defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants: {
    blueScribbleModal,
  },
});
